<template>
  <v-data-table
    :headers="headers"
    :items="servicePlans"
    show-expand
    single-expand
    :expanded.sync="expanded"
    item-key="servicePlanId"
    :item-class="highlightExpandedRow"
    :items-per-page="-1"
    hide-default-footer
    class="primary--text"
    :key="servicePlans.length"
    @click:row="rowClicked"
    :sort-by="['program', 'service', 'startDate']"
    :sort-desc="[false, false, true]"
  >
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="expandedRow">
        <provider-assignments-table
          :viewOnly="viewOnly"
          :servicePlanId="item.servicePlanId"
        ></provider-assignments-table>
        <v-card-actions class="justify-center white mb-3 py-3">
          <provider-assignment-form
            v-if="!viewOnly && item.isSeitOrPend"
            :servicePlanId="item.servicePlanId"
          ></provider-assignment-form>
        </v-card-actions>
      </td>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <service-plan-form
        v-if="!viewOnly"
        :planId="planId"
        :servicePlan="item"
      ></service-plan-form>
    </template>
    <template v-if="canEdit" v-slot:[`footer`]="{}">
      <v-card-actions class="justify-center">
        <service-plan-form
          v-if="!viewOnly"
          :planId="planId"
        ></service-plan-form>
      </v-card-actions>
    </template>
  </v-data-table>
</template>

<script>
import ServicePlanForm from "./service-plan-form";
import ProviderAssignmentsTable from "./provider-assignments-table";
import ProviderAssignmentForm from "./provider-assignment-form.vue";
export default {
  components: {
    ServicePlanForm,
    ProviderAssignmentsTable,
    ProviderAssignmentForm,
  },
  props: ["planId", "viewOnly"],
  data() {
    return {
      headers: [
        { text: "Program", value: "program" },
        { text: "Service", value: "service" },
        { text: "Mandate", value: "mandate" },
        { text: "Location", value: "sessionLocation" },
        { text: "Auth Start Date", value: "formattedStartDate" },
        { text: "Auth End Date", value: "formattedEndDate" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      expanded: [],
    };
  },
  computed: {
    canEdit() {
      return (
        this.$store.getters["securityModule/isEIAdmin"] ||
        this.$store.getters["securityModule/isSEITAdmin"]
      );
    },
    servicePlans() {
      var plan = this.$store.state.plansModule.plans.find(
        (item) => item.planId == this.planId
      );
      return plan.servicePlans;
    },
  },
  methods: {
    rowClicked: function (row, { isExpanded }) {
      this.expanded = isExpanded ? [] : [row];
    },
    highlightExpandedRow: function (row) {
      return (
        this.expanded[0]?.servicePlanId === row.servicePlanId && "expandedRow"
      );
    },
  },
};
</script>
<style>
.expandedRow {
  background: #ccc;
}
</style>
